import { ROBOT_MODELS, UnknownModel } from '.'

export function getRobotModelNameById(id: string): string {
  const model = ROBOT_MODELS.find((model) => model.id === id)
  return model ? model.name : UnknownModel.name
}

